module.exports = __webpack_public_path__ + "img/entschenkopf.c44f0e2a.jpg";